function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
|---------------------------------------------------------------------
| Navigation Menu Item Component
|---------------------------------------------------------------------
|
| Navigation items for the NavMenu component
|
*/
import { GA_EVENTS } from "@/js/constants";
import { mapState } from 'vuex';
export default {
  props: {
    menuItem: {
      type: Object,
      default: function _default() {}
    },
    subgroup: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    sinIcono: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: false,
      isHover: false
    };
  },
  watch: {
    $route: function $route(to, from) {
      //console.log("change route")
      this.isSelected();
    }
  },
  created: function created() {
    this.isSelected();
  },
  computed: _objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])),
  methods: {
    isSelected: function isSelected() {
      //console.log(this.menuItem.link, " == ", this.$router.history.current.path)
      if (this.menuItem.link == this.$router.history.current.path) {
        this.selected = true;
        this.pushDataLayer(this.menuItem);
      } else {
        this.selected = false;
      }
    },
    pushDataLayer: function pushDataLayer(menuItem) {
      var module_ = this.obtenerModulo(menuItem.key);
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.SELECT_MENU,
          element_name: this.getmenu(menuItem.key),
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          'module': module_
        });
      }
    },
    obtenerModulo: function obtenerModulo(cadena) {
      var secciones = cadena.split(".");
      var valor = secciones[1];
      var textosPersonalizados = {
        dp: "data_platform",
        aud: "digital_audiences",
        attrs: "attributes_marketplace",
        customer: "customer_insights",
        analytic: "analytic_services"
      };
      var textoPersonalizado = textosPersonalizados[valor];
      return textoPersonalizado;
    }
  }
};